module.exports = __webpack_public_path__ + "img/more.60a94101.svg";